module.exports = __webpack_public_path__ + "img/interruptores_termomagneticos.a4d4a270.jpg";